// https://tula.house/pages/portfolio
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const container = document.getElementById('tula-gardens-portfolio');
    if (!container) return;

    const links = container.querySelectorAll('a.imagebox.xo-blank');
    links.forEach(link => {
      const titleEl = link.querySelector('.imagebox__title');
      if (titleEl) {
        link.setAttribute('aria-label', titleEl.textContent.trim());
      }
    });
  }, 2000); // 2000 milliseconds = 2 seconds
});